// extracted by mini-css-extract-plugin
export default {"navHead":"_29NqY"};